import script from "./ServerView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServerView.vue?vue&type=script&lang=ts&setup=true"

import "./ServerView.vue?vue&type=style&index=0&id=78ce3cf1&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ce3cf1"]])

export default __exports__